export { default } from './page/_index.tsx';
import { json, LinksFunction } from '@remix-run/node';
import type { MetaFunction } from '@remix-run/node';
import { externalAction, externalLoader } from '~/utils/externalLoader.server';
export const action = externalAction;
export const loader = externalLoader;
import { useTranslation } from 'react-i18next';

export const meta: MetaFunction = ({ data }: any) => {
	let { t } = useTranslation(['references']);

	let lang = data.userLanguage === 'de' ? '' : data.userLanguage + '/';

	return [
		{
			title: t('routeTitle'),
		},
		{
			name: 'title',
			content: t('routeTitle'),
		},
		{
			property: 'og:title',
			content: t('routeTitle'),
		},
		{
			name: 'twitter:title',
			content: t('routeTitle'),
		},

		{
			name: 'description',
			content: t('routeOther'),
		},
		{
			name: 'og:description',
			content: t('routeOther'),
		},
		{
			name: 'twitter:description',
			content: t('routeOther'),
		},
		{
			property: 'og:url',
			content: 'https://northrock.software/' + lang + 'references/',
		},
		{
			name: 'twitter:url',
			content: 'https://northrock.software/' + lang + 'references/',
		},
	];
};

import clientMaintainBasis from '~/content/svg/clients/maintain_basis.webp';
import clientMD from '~/content/svg/clients/mde.svg';
import clientMaintainBML from '~/content/svg/clients/maintain_bml.svg';
import clientAwen from '~/content/svg/clients/awen.svg';
import clientBayern from '~/content/svg/clients/bayern_staatsregierung.webp';
// import clientESA from '~/content/svg/clients/ESA_BIC_Hessen.webp';
import clientRecord from '~/content/svg/clients/record_evolution.webp';
import client711 from '~/content/svg/clients/logo-711.webp';

export const links: LinksFunction = () => {
	return [
		{
			rel: 'preload',
			href: clientMaintainBasis,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientMD,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientMaintainBML,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientAwen,
			as: 'image',
		},
		{
			rel: 'preload',
			href: clientBayern,
			as: 'image',
		},
		// {
		// 	rel: 'preload',
		// 	href: clientESA,
		// 	as: 'image',
		// },
		{
			rel: 'preload',
			href: clientRecord,
			as: 'image',
		},
		{
			rel: 'preload',
			href: client711,
			as: 'image',
		},
	];
};
